export default __webpack_public_path__ + "images/medal.c85b870d.png";